export function monthLabel(year, month) {
  return new Date(year, month - 1, 1).toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
}

export function shiftYearMonth(year, month, delta) {
  const d = new Date(year, month - 1 + delta, 1);
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
}

export function monthIsoBounds(year, month) {
  const pad = (n) => String(n).padStart(2, '0');
  const last = new Date(year, month, 0).getDate();
  return {
    von: `${year}-${pad(month)}-01`,
    bis: `${year}-${pad(month)}-${pad(last)}`,
  };
}
